import React from "react";
import { ReserveFormMeetingRoomUsersSelector } from "@/components/reserve/Reserve/controls/ReserveFormMeetingRoomUsersSelector";
import { useReserveForm } from "@/components/reserve/Reserve/ReserveFormProvider";
import { cn } from "@gettactic/helpers";

export interface ReserveFormMeetingRoomUsersProps {
  className?: string;
  defaultUsers?: string[];
}

export const ReserveFormMeetingRoomUsers: React.FC<
  ReserveFormMeetingRoomUsersProps
> = ({ className, defaultUsers }) => {
  const { isMeetingRoom } = useReserveForm();
  if (!isMeetingRoom) return null;

  return (
    <div className={cn("text-left", className)}>
      <ReserveFormMeetingRoomUsersSelector defaultUsers={defaultUsers} />
    </div>
  );
};
